import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    meta: {
      title: "Home",
    },
    component: () => import("../layouts/main.vue"),
    children: [
      {
        path: "/",
        name: "Home",
        meta: {
          title: "Home",
        },
        component: () => import("../views/Home.vue"),
      },
      {
        path: "/accounts",
        name: "Accounts",
        meta: {
          title: "Accounts",
          prtitle: "حساب ها",
        },
        component: () => import("../views/Account/Accounts.vue"),
      },
      {
        path: "/businessaccounts",
        name: "BusinessAccounts",
        meta: {
          title: "BusinessAccounts",
          prtitle: "حساب‌های تجاری",
        },
        component: () => import("../views/BusinessAccounts/List.vue"),
      },
    ],
  },
  {
    path: "/inside",
    component: () => import("../layouts/inside.vue"),
    children: [
      {
        path: "/transaction/:amount",
        name: "Transaction",
        meta: {
          title: "Transaction",
        },
        component: () => import("../views/Transaction.vue"),
      },
      {
        path: "/destination/:amount",
        name: "Destination",
        meta: {
          title: "destination",
          prtitle: " پرداخت",
        },
        component: () => import("../views/Transaction/Destination.vue"),
      },
    ],
  },
  {
    path: "/default",
    component: () => import("../layouts/default.vue"),
    children: [
      // {
      //   path: "/",
      //   name: "Login",
      //   meta: { title: "Login" },
      //   component: () => import("../views/Login.vue"),
      // },

      {
        path: "/about",
        name: "About",
        meta: {
          title: "About",
        },
        component: () => import("../views/About.vue"),
      },
    ],
  },
  {
    path: "/default",
    component: () => import("../layouts/default.vue"),
    children: [
      {
        path: "/transactions",
        name: "Transactions",
        meta: {
          title: "Transactions",
          prtitle: "تراکنش‌های‌اخیر",
        },
        component: () => import("../views/Transaction/Transactions.vue"),
      },
      {
        path: "/transactions/filters",
        name: "Filters",
        meta: {
          title: "Filters",
          prtitle: "فیلتر‌ها",
        },
        component: () => import("../views/Transaction/components/Filters.vue"),
      },
      {
        path: "/confirmation",
        name: "Confirmation",
        meta: {
          title: "Confirmation",
          prtitle: "تایید تراکنش",
        },
        component: () => import("../views/Transaction/Confirmation.vue"),
      },
      {
        path: "/success",
        name: "Success",
        meta: {
          title: "Success",
          prtitle: "تراکنش موفق",
        },
        component: () => import("../views/Transaction/Success.vue"),
      },
      {
        path: "/notificationsetting",
        name: "NotificationSetting",
        meta: {
          title: "NotificationSetting",
          prtitle: "تنظیمات اعلان",
        },
        component: () => import("../views/menu/NotificationSetting.vue"),
      },
      {
        path: "/securitysetting",
        name: "SecuritySetting",
        meta: {
          title: "SecuritySetting",
          prtitle: "امنیت",
        },
        component: () => import("../views/menu/SecuritySetting.vue"),
      },
      {
        path: "/profile",
        name: "Profile",
        meta: {
          title: "Profile",
          prtitle: "حساب کاربری",
        },
        component: () => import("../views/menu/Profile.vue"),
      },
      {
        path: "/devicesession",
        name: "DeviceSession",
        meta: {
          title: "DeviceSession",
          prtitle: "دستگاه‌های شما",
        },
        component: () => import("../views/menu/ActiveSession.vue"),
      },
      {
        path: "/inviteother",
        name: "InviteOther",
        meta: {
          title: "InviteOther",
          prtitle: "دعوت از دیگران",
        },
        component: () => import("../views/menu/InviteOther"),
      },
      {
        path: "/support",
        name: "Support",
        meta: {
          title: "Support",
          prtitle: "پشتیبانی",
        },
        component: () => import("../views/menu/Support.vue"),
      },
      {
        path: "/ticket/list",
        name: "Ticket",
        meta: {
          title: "Ticket",
          prtitle: "تیکت ها",
        },
        component: () => import("../views/menu/Ticket/List.vue"),
      },
      {
        path: "/ticket/add",
        name: "SendTicket",
        meta: {
          title: "ticket",
          prtitle: "ارسال تیکت",
        },
        component: () => import("../views/menu/Ticket/Add.vue"),
      },
      {
        path: "/accounts/add",
        name: "AddAccounts",
        meta: {
          title: "AddAccounts",
          // prtitle: "تراکنش موفق",
        },
        component: () => import("../views/Account/Add.vue"),
      },
      {
        path: "/businessaccounts/add",
        name: "AddBusinessAccounts",
        meta: {
          title: "AddAccounts",
          // prtitle: "تراکنش موفق",
        },
        component: () => import("../views/BusinessAccounts/Add.vue"),
      },

      {
        path: "/:path(.*)",
        component: () => import("../views/NotFound.vue"),
      },
      {
        path: "/register",
        name: "Register",
        meta: {
          title: "Register",
        },
        component: () => import("../views/Register/Register.vue"),
      },
      {
        path: "/password",
        name: "Password",
        meta: {
          title: "Password",
        },
        component: () => import("../views/Register/insertPassword.vue"),
      },
      {
        path: "/chengepassword",
        name: "ChengePassword",
        meta: {
          title: "ChengePassword",
        },
        component: () => import("../views/menu/ChengePassword.vue"),
      },
      {
        path: "/login",
        name: "Login",
        meta: {
          title: "Login",
        },
        component: () => import("../views/Register/login.vue"),
      },
      {
        path: "/fingerprint",
        name: "Fingerprint",
        meta: {
          title: "Fingerprint",
        },
        component: () => import("../views/Register/Fingerprint.vue"),
      },
      {
        path: "/logout",
        name: "LogOut",
        meta: {
          title: "LogOut",
        },
        component: () => import("../views/Register/Logout.vue"),
      },
      {
        path: "/menu",
        name: "Menu",
        meta: {
          title: "menu",
          pr: "منو",
        },
        component: () => import("../layouts/menu.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
